<template>
    <ModalBackground :hideOnClickOutside="false">
        <div class="modal-confirm">
            <div>
                <h2>{{title}}</h2>
                <p>{{content}}</p>
                <footer>
                    <PrimaryButton v-if="showCancel" @click="onCancel">{{getCancelLabel}}</PrimaryButton>
                    <PrimaryButton v-if="showOk" @click="onOK">{{getConfirmLabel}}</PrimaryButton>
                </footer>
            </div>
        </div>
    </ModalBackground>
</template>

<i18n>
{
    "en": {
        "modals": {
            "confirm": {
                "ok": "Ok",
                "cancel": "Cancel",
                "yes": "Yes",
                "no": "No"
            }
        }
    },
    "es": {
        "modals": {
            "confirm": {
                "ok": "Ok",
                "cancel": "Cancelar",
                "yes": "Sí",
                "no": "No"
            }
        }
    },
    "fr": {
        "modals": {
            "confirm": {
                "ok": "Ok",
                "cancel": "Annuler",
                "yes": "Oui",
                "no": "Non"
            }
        }
    },
    "pt": {
        "modals": {
            "confirm": {
                "ok": "Ok",
                "cancel": "Cancelar",
                "yes": "Sim",
                "no": "Não"
            }
        }
    },
    "de": {
        "modals": {
            "confirm": {
                "ok": "Ok",
                "cancel": "Abbrechen",
                "yes": "Ja",
                "no": "Nein"
            }
        }
    },
    "nl": {
        "modals": {
            "confirm": {
                "ok": "Ok",
                "cancel": "Annuleren",
                "yes": "Ja",
                "no": "Geen"
            }
        }
    }
}
</i18n>

<script>
import ModalBase from './ModalBase.vue'
import ModalBackground from './ModalBackground.vue'
import PrimaryButton from '@/components/v3/buttons/PrimaryButton.vue'

export default {
    extends: ModalBase,
    components: {
        ModalBase,
        ModalBackground,
        PrimaryButton
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        item: {
            type: Object,
            default: null
        },
        showOk: {
            type: Boolean,
            default: true
        },
        showCancel: {
            type: Boolean,
            default: true
        },
        isYesOrNo: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        getConfirmLabel() {
            return this.isYesOrNo ? this.$t('modals.confirm.yes') : this.$t('modals.confirm.ok')
        },
        getCancelLabel() {
            return this.isYesOrNo ? this.$t('modals.confirm.no') : this.$t('modals.confirm.cancel')
        }
    },
    methods: {
        onOK() {
            if (this.item && this.item.callback) {
                this.item.callback(true)
            }
            this.removeModal()
        },
        onCancel() {
            if (this.item && this.item.callback) {
                this.item.callback(false)
            }
            this.removeModal()
        },
        removeModal() {
            this.$emit('remove', this)
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.modal-confirm
    width auto
    background-color $color-primary-text
    height fit-content
    border-radius 5px
    box-shadow 0 4px 4px rgba(0, 0, 0, 0.2)
    display flex
    flex-direction column
    justify-content center
    align-items center
    box-sizing border-box
    padding 36px
    max-width 476px

    h2
        margin-top 0
        margin-bottom 36px
        color $color-primary

    footer
        display flex
        flex-direction row
        margin-top 48px
        justify-content flex-end

        // .primary-button
        //     background-color $color-primary-text
        //     color $color-primary
</style>



// WEBPACK FOOTER //
// src/modules/modals/components/ModalConfirm.vue